export default __webpack_public_path__ + "static/AGaramondPro-Bold-17131c580c7a9cdebeeedcf422a2bb9c.otf";